import { RouterReducerState } from '@ngrx/router-store';
import { createSelector } from '@ngrx/store';

import {
  CURRENT_USER_INITIAL_STATE,
  CurrentUserState,
} from '®shared/current-user/current-user.state';
import {
  TENANT_INITIAL_STATE,
  TenantState,
  getActiveImportances,
  getActiveLocales,
  getActiveTimePeriods,
  getBookstores,
  getCitationStyles,
  getDefaultListAccess,
  getDefaultLocale,
  getLicenses,
  getTenant,
} from '®shared/tenant/tenant.state';

export interface State {
  currentUser: CurrentUserState;
  router: RouterReducerState;
  tenancy: TenantState;
}

export const INITIAL_STATE: State = {
  currentUser: CURRENT_USER_INITIAL_STATE,
  router: null,
  tenancy: TENANT_INITIAL_STATE,
};

export function getInitialState(): State {
  return INITIAL_STATE;
}

export const getCurrentUserState = (state: State): CurrentUserState =>
  state.currentUser;

export const getTenancyState = (state: State): TenantState => state.tenancy;

export const selectCurrentUser = createSelector(
  getCurrentUserState,
  user => user.loadableUser,
);

export const selectCurrentUserGuid = createSelector(
  getCurrentUserState,
  (userState: CurrentUserState) =>
    (userState &&
      userState.loadableUser &&
      userState.loadableUser.data &&
      userState.loadableUser.data.oauthUser &&
      userState.loadableUser.data.oauthUser.guid) ||
    null,
);

export const selectTenant = createSelector(getTenancyState, getTenant);

export const selectTenantShortCode = createSelector(
  selectTenant,
  tenant => tenant.short_code,
);

export const selectBookstores = createSelector(selectTenant, getBookstores);

export const selectCitationStyles = createSelector(
  selectTenant,
  getCitationStyles,
);

export const selectDefaultListAccess = createSelector(
  selectTenant,
  getDefaultListAccess,
);

export const selectImportances = createSelector(
  selectTenant,
  getActiveImportances,
);

export const selectDefaultLocale = createSelector(
  selectTenant,
  getDefaultLocale,
);

export const selectActiveLocales = createSelector(
  selectTenant,
  getActiveLocales,
);

export const selectLicenses = createSelector(selectTenant, getLicenses);

export const selectActiveTimePeriods = createSelector(
  selectTenant,
  getActiveTimePeriods,
);
